import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const CheckScanningConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "checkScanning" */ '../../../components/CheckScans/CheckScanning'
    ),
  teamOwner: 'bank-transfers',
  sentryTeam: 'bank_transfers',
  enabledOverrideFlag: 'enable_check_scanning_component',
  releaseState: 'preview',
  description: 'Allow a user to scan a check',
  friendlyName: 'Check scanning',
  docSitePath: '/connect/supported-embedded-components/check-scanning',
  customHtmlElementMethods: {
    setHandleCheckScanSubmitted: {
      type: 'SupplementalFunction',
      objectToSet: 'handleCheckScanSubmitted',
      isInternal: false,
      description:
        'Sets the function to be called when the check scan is submitted and ready for use.',
    },
  },
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/check-scanning?filterState=ALL',
  },
};
